import type { ClientArgs, ClientInferResponseBody } from '@ts-rest/core';
import type { UseQueryOptions } from '@ts-rest/react-query/v5';

import type { OccupationsContract } from '@packages/contracts';

import { OCCUPATION_QUERY_KEY } from '../query-keys';

type OccupationRootsRoute = typeof OccupationsContract['listRoots'];
type OccupationRootsResponse = ClientInferResponseBody<OccupationRootsRoute, 200>['result']['occupations'];

export type OccupationRootsQueryOptions = UseQueryOptions<
	OccupationRootsRoute,
	ClientArgs,
	OccupationRootsResponse
>;

export const createOccupationRootsQueryOptions = (): OccupationRootsQueryOptions => ({
	queryKey: OCCUPATION_QUERY_KEY.roots,

	retry: (failureCount, error) => {
		if ('statusCode' in error && (error.statusCode === 404 || error.statusCode === 400)) return false;

		return failureCount < 3;
	},
	select: res => res.body.result.occupations,
});
